// CoordinatorRouter.tsx
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {checkCoordinatorStatus} from '../../../api/coordiApi';
import {handleTokenResponse, upgradeToCoordinator} from '../../../api/authApi';
import {getAuthInfo} from '../../../utils/authUtils';
import {Loading} from "../../../components/common/Loading";

export default function CoordinatorRouter() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        checkStatus();
    }, []);

    const checkStatus = async () => {
        try {
            const res = await checkCoordinatorStatus();
            // code가 "00"이 아니면 데이터 없음 (NOT_FOUND 등)
            if (res.data.code !== "00") {
                // 코디 정보 없음 -> 신청 페이지
                navigate('/coordi/apply', {replace: true});
                return;
            }
            const status: string = res.data.data;

            if (!status) {
                navigate('/coordi/apply', {replace: true});
            } else if (status === 'REGISTERED') {
                navigate('/coordi/apply/detail', {replace: true});
            } else if (status === 'DENY') {
                navigate('/coordi/apply/denied', {replace: true});
            } else if (status === 'COMPLETE') {
                // 현재 role이 ROLE_MEMBER이면 코디로 토큰 업그레이드 후 진입
                const authInfo = getAuthInfo();
                if (authInfo?.role === 'ROLE_MEMBER') {
                    try {
                        const upgradeRes = await upgradeToCoordinator();
                        if (upgradeRes.data.code === '00') {
                            handleTokenResponse(upgradeRes.data);
                        }
                    } catch (upgradeError) {
                        // 업그레이드 실패해도 코디 페이지는 진입 허용 (다음 로그인 시 자동 적용)
                        console.warn('코디 토큰 업그레이드 실패:', upgradeError);
                    }
                }
                navigate('/coordi/detail', {replace: true});
            }
        } catch (error) {
            console.error('Failed to check coordinator status:', error);
            // 에러 시 신청 페이지로
            navigate('/coordi/apply', {replace: true});
        }
    };

    return (
        <Loading loading={loading} onClose={() => setLoading(false)}/>
    );
}